class searchForm {
	constructor(config) {
		this.config = Object.assign({
			scope: '.header',
			toggle: '.open-search'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.on('click', this.config.toggle, this.toggleSearch.bind(this));

		let $form = $('body').find('.search-form');
		$form.on('click', '.search-clear', this.clearSearch.bind(this));
		$form.on('input', 'input[name="q"]', this.toggleClearButton.bind(this));
	}

	toggleSearch(event) {
		event.preventDefault();
		let $target = $(event.currentTarget);
		$('body').find('.search-form').toggleClass('show');
	}

	clearSearch(event) {
		event.preventDefault();
		let $form = $(event.currentTarget).closest('form');
		let $input = $form.find('input[name="q"]');
		$input.val('').trigger('input').trigger('change').focus();
		$form.closest('.search-form').removeClass('started-search');
	}

	toggleClearButton(event) {
		let $input = $(event.currentTarget);
		let $btn = $input.closest('form').find('.search-clear');
		$btn.toggleClass('d-none', $input.val().length === 0);
	}
}

export default new searchForm;